import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  库存新增
export function qukuListAll (data) {
  return request({
    url: baseURL + 'quku/listAll',
    method: 'post',
    data: data
  })
}
//  库存新增
export function qukuAdd (data) {
  return request({
    url: baseURL + 'quku/add',
    method: 'post',
    data: data
  })
}
//  库存查询
export function qukuList (data) {
  return request({
    url: baseURL + 'quku/list',
    method: 'post',
    data: data
  })
}
//  库存删除
export function qukuDelete (data) {
  return request({
    url: baseURL + 'quku/delete',
    method: 'post',
    data: data
  })
}

//  库存修改
export function qukuUpdate (data) {
  return request({
    url: baseURL + 'quku/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/quku/index.js